var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-space-between align-content-center"},[_vm._t("default"),_c('v-btn',{staticClass:"align-self-center",attrs:{"icon":"","color":"orange"},on:{"click":_vm.scrollToMessage}},[_c('v-icon',[_vm._v("mdi-email-search")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }